import React, { useEffect, useState } from 'react';

const LocalStorageDebug: React.FC = () => {
  const [userData, setUserData] = useState<any>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isTeacher, setIsTeacher] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');

      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUserData(parsedUser);

        // Check for both role (string) and roles (array) formats
        if (parsedUser.roles && Array.isArray(parsedUser.roles)) {
          // If roles array exists, check it
          setIsAdmin(parsedUser.roles.some((role: string) =>
            typeof role === 'string' && role.toUpperCase() === 'ADMIN'));

          setIsTeacher(parsedUser.roles.some((role: string) =>
            typeof role === 'string' && role.toUpperCase() === 'TEACHER'));
        } else if (parsedUser.role) {
          // If single role string exists, check it
          const roleUpper = parsedUser.role.toUpperCase();
          setIsAdmin(roleUpper === 'ADMIN');
          setIsTeacher(roleUpper === 'TEACHER');
        } else {
          setError("User data doesn't contain valid role information");
        }
      } else {
        setError("No user data found in localStorage");
      }
    } catch (e) {
      setError(`Error parsing user data: ${e instanceof Error ? e.message : String(e)}`);
    }
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-xl font-bold mb-4">LocalStorage Debug Information</h1>

      {error ? (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      ) : null}

      <div className="mb-4">
        <h2 className="text-lg font-semibold">User Role Status:</h2>
        <p className="mb-1">Is Admin: <span className={isAdmin ? "text-green-600 font-bold" : "text-red-600"}>{String(isAdmin)}</span></p>
        <p>Is Teacher: <span className={isTeacher ? "text-green-600 font-bold" : "text-red-600"}>{String(isTeacher)}</span></p>
      </div>

      <div className="mb-4">
        <h2 className="text-lg font-semibold">Raw localStorage user data:</h2>
        <pre className="bg-gray-100 p-3 rounded overflow-auto max-h-96">
          {JSON.stringify(userData, null, 2)}
        </pre>
      </div>

      <div>
        <h2 className="text-lg font-semibold">Test Menu</h2>
        <div className="relative inline-block">
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Admin Tools (Test)
          </button>
          <div className="absolute hidden group-hover:block right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10 border border-gray-200">
            <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              Manage Users
            </div>
            <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              Manage Events
            </div>
            <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              User Approvals
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalStorageDebug;
